import { Link } from 'react-router-dom';

const Hero = () => {
    return (
        <div className="relative h-screen bg-cover bg-center" style={{ backgroundImage: "url('/assets/business-teamwork-join-hands-together-business-teamwork-concept.jpg')" }}>
            {/* Overlay */}
            <div className="absolute inset-0 bg-black/50"></div>

            {/* Content */}
            <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 max-w-5xl mx-auto">
                <h1 className="text-[#D99C3B] font-serif text-4xl md:text-5xl lg:text-7xl font-bold mb-6 leading-tight drop-shadow-lg">
                    Empowering Independence <br /> & Community Participation for All
                </h1>
                <p className="text-white text-lg md:text-2xl mb-12 max-w-4xl font-light leading-relaxed drop-shadow-md">
                    Community Plus Care Services is a trusted NDIS provider delivering personalised, culturally respectful disability supports across Australia.
                </p>
                <Link
                    to="/register"
                    className="bg-[#008080] text-white font-bold py-4 px-12 rounded-full uppercase tracking-widest hover:bg-teal-700 transition-colors duration-300 shadow-lg border-2 border-teal-400"
                >
                    Register Now
                </Link>
            </div>
        </div>
    );
};

export default Hero;
